import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`.input-container:focus-within > inv-icon {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}

.dropdown-menu {
    position: absolute;
    z-index: var(--inv-dropdown-z-index, 1000);
    display: none;
    min-width: var(--inv-dropdown-min-width, 10em);
    max-height: var(--inv-dropdown-max-width, 10em);
    overflow-y: scroll;
    padding: var(--inv-dropdown-padding-y, 0.5em) var(--inv-dropdown-padding-x, 0);
    margin: 0;
    font-size: var(--inv-dropdown-font-size, 1em);
    color: var(--inv-dropdown-color, #212529);
    text-align: left;
    list-style: none;
    background-color: var(--inv-dropdown-background, #fff);
    background-clip: padding-box;
    border: var(--inv-dropdown-border-width, 0.05em) solid var(--inv-dropdown-border-color, rgba(0, 0, 0, 0.175));
    border-radius: var(--inv-dropdown-border-radius, 0.375em);
    inset: 0 auto auto 0;
    transform: translate3d(0px, 3em, 0px);
}

.dropdown-menu.show {
    display: block;
    width: 100%;
}
`); export default styleSheet;